module.exports = [
  {
    name: 'Blue',
    hex: '#2A98F0'
  },
  {
    name: 'Hibiscus',
    hex: '#C82F68'
  },
  {
    name: 'Orange',
    hex: '#F59000'
  },
  {
    name: 'Purple',
    hex: '#7A3EF3'
  },
  {
    name: 'Green',
    hex: '#54B352'
  }
]
